const encoder = new TextEncoder

export async function strToBase64(str: string) {
  return globalThis.btoa(Array.from(encoder.encode(str), byte => 
    String.fromCodePoint(byte)).join(""))
}

